import CheckboxViolet from "@UI/New/ChecboxViolet/CheckboxViolet";
import classNames from "classnames";
import s from "./checkboxEmpty.module.css"

const CheckboxEmpty = ({
    value,
    disabled
}) => {
    return <CheckboxViolet
        value={value}
        className={s.checkboxViolet}
        blockClassName={classNames({
            [s.checkboxColor]: value},
            {[s.checkboxBlock]: !disabled},
            {[s.checkboxBlockDisabled]: disabled}
        )}
        textClassName={s.checkboxText}
        noCheckImg={disabled && !value}
    />;
}

export default CheckboxEmpty;